/* eslint-disable import/prefer-default-export */
import { graphql, useStaticQuery } from 'gatsby'

export const useTrustLogos = () => {
  const data = useStaticQuery(graphql`
    query NewTrustMarksQuery {
      allWpTrustmarksection {
        nodes {
          id
          trustmarkpresets {
            logotypes {
              nodes {
                ... on WpTrustitem {
                  id
                  title
                  trustmarkpresets {
                    logo {
                      node {
                        altText
                        sourceUrl
                        localFile {
                          childImageSharp {
                            gatsbyImageData(
                              quality: 80
                              webpOptions: { quality: 80 }
                              avifOptions: { lossless: true, quality: 80 }
                            )
                          }
                        }
                        mediaItemUrl
                        mediaType
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  return data.allWpTrustmarksection.nodes[0].trustmarkpresets.logotypes.nodes
}
